import React from 'react';
import { render } from 'react-dom';
import App from '../src/containers/App/App';
import { initializeApiSettings } from './fragmentIntegration/apiSettings';
import './index.css';

initializeApiSettings();

render(<App />, document.getElementById('root'));